<template>
    <aside class="fly-out pf c-el-panel-bg br-m"
        :style="columnsStyle"
        :class="[
            visible ? 'visible' : '',
            rightSide ? 'right-side' : 'left-side',
            visible && UIMobile ? 'visible-mobile' : '',
            UIMobile ? 'el-mobile-fly-out' : 'sm-l br-m bs-l',
            fullHeight ? 'el-flyout-full-height' : '',
            columns ? 'el-flyout-columns' : '',
            fullscreen ? 'el-flyout-fullscreen' : '']">
        <slot name="content"></slot>
    </aside>
</template>
<script>
import UIMobileMixin from '../../mixins/UIMobile';

export default {
    name: 'mead-fly-out',
    mixins: [UIMobileMixin],
    props: {
        /**
         * Whether the fly-out panel is currently shown. Toggles the sliding
         * transition that brings the panel on/off screen.
         */
        visible: {type: Boolean, default: false},
        /**
         * Whether the panel slides in from the right side of the screen. When
         * false, it slides in from the left side instead.
         */
        rightSide: {type: Boolean, default: true},
        /**
         * Whether the panel expands to cover the full screen instead of docking
         * to one side at a fixed width.
         */
        fullscreen: {type: Boolean, default: false},
        /**
         * Whether the panel stretches the full height of the screen, keeping
         * the same spacing from the top and bottom edges as it has from the side.
         */
        fullHeight: {type: Boolean, default: false},
        /**
         * Width of the panel in grid columns (1-12) of the screen width, e.g. 6
         * covers half the screen. Leave at 0 to keep the default fixed width.
         */
        columns: {type: Number, default: 0},
    },
    computed: {
        columnsStyle: function () {
            return this.columns ? {'--fly-out-columns': this.columns} : {};
        },
    },
};
</script>
<style lang="scss" scoped>
@use '../../../sass/variables' as *;
.fly-out {
    top: 12rem;
    width: 40rem;
    max-width: 100%;
    bottom: 0;
    z-index: $zx-fly-out;
    transition: all 0.3s ease-out;
    opacity: 0;

    // Fade in place instead of sliding
    @media (prefers-reduced-motion: reduce) {
        transition: opacity 0.2s ease-out;
    }

    // Width in grid columns of the screen, less the panel's margin on either side
    &.el-flyout-columns {
        width: calc((100vw - #{$s-l * 2}) * var(--fly-out-columns) / 12);
    }

    &.el-flyout-full-height {
        top: 0;
    }

    // Flyout shows up on the right side
    &.right-side {
        right: 0;
        transform: translateX(calc(100% + #{$s-l}));
        left: auto;

        &.el-mobile-fly-out {
            width: 100%;
            left: 100%;
        }

        &.visible-mobile {
            left: 0;
            right: 100%
        }
    }

    // Flyout shows up on the left side
    &.left-side {
        left: 0;
        transform: translateX(calc(-100% - #{$s-l}));
        right: auto;

        &.el-mobile-fly-out {
            width: 100%;
            right: 0;
            left: -100%;
        }

        &.visible-mobile {
            right: 100%;
            left: 0;
        }
    }

    &.visible {
        transform: translateX(0);
        opacity: 1;
    }

    &.el-flyout-fullscreen {
        left: 0;
        right: 0;
        top: 0;
        width: initial;
    }
}
</style>
